import React from 'react'

export default function CancelSendIcon(){
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M3 12C3 7.02937 7.02937 3 12 3C16.9706 3 21 7.02937 21 12C21 16.9706 16.9706 21 12 21C7.02937 21 3 16.9706 3 12ZM8.8617 7.51174C8.90134 7.5042 8.94019 7.49981 8.97656 7.5C9.08569 7.50056 9.1794 7.53697 9.25665 7.6137L12 10.3559L14.7434 7.6137C15.292 7.06526 16.9385 8.71058 16.3898 9.25901L13.6465 12.0012L16.3898 14.7434C16.9385 15.2918 15.292 16.9384 14.7434 16.3898L12 13.6465L9.25665 16.3899C8.70799 16.9384 7.06155 15.2919 7.61018 14.7434L10.3535 12.0012L7.61014 9.25901C7.1643 8.8134 8.17556 7.64059 8.8617 7.51174Z" fill="#F04438"/>
        </svg>
    )
}
